import * as types from './types'
import { EntityHistoryData, EntityParams } from 'app/models/entity-params'
import { EntitySnapshotParams } from 'app/models/snapshot-params'
import { createReducer } from 'app/state/utils'


export interface EntitiesState {
  entities: EntityParams[];   // Array of Entity objects
  entity: EntityParams | null; // Single entity or null
  isLoading: boolean;
  entityHistory: EntityHistoryData[]
  entitySnapshot?: EntitySnapshotParams
}

const initialState: EntitiesState = { entities: [], entity: null, isLoading: false, entityHistory: [], entitySnapshot: undefined }

const entitiesReducer = createReducer(initialState)({
  [types.GET_ENTITIES]: (state: any, payload: any) => {
    return { ...state, entities: payload.payload }
  },
  [types.GET_ENTITY]: (state: any, payload: any) => {
    return { ...state, entity: payload.payload }
  },
  [types.GET_ENTITY_SNAPSHOT]: (state: any, payload: any) => {
    return { ...state, entitySnapshot: payload.payload }
  },
  [types.ADD_ENTITIES]: (state: any, payload: any) => {
    return {
      ...state,
      entities: [payload.payload.data, ...state.entities],
    }
  },
  [types.EDIT_ENTITIES]: (state: any, payload: any) => {
    const index = state.entities.findIndex(
      (entity: { id: any }) => entity.id === payload.payload.data.id
    )
    const newArray = [...state.entities]
    newArray[index] = { ...payload.payload.data }
    return {
      ...state,
      entities: newArray,
      entity: payload.payload.data,
    }
  },
  [types.ACTIVE_ENTITY]: (state: any, payload: any) => {
    const index = state.entities.findIndex(
      (entity: { id: any }) => entity.id === payload.payload.id
    )
    const newArray = [...state.entities]
    if (index >= 0) {
      newArray[index] = { ...newArray[index], ...payload.payload, status: 'Active' }
    }
    if (payload.payload.id === state.entity?.id) {
      return {
        ...state,
        entity: { ...state.entity, ...payload.payload, status: 'Active' },
        entities: newArray,
      }
    }
    return {
      ...state,
      entities: newArray,
    }
  },
  [types.INACTIVE_ENTITY]: (state: any, payload: any) => {
    const index = state.entities.findIndex(
      (entity: { id: any }) => entity.id === payload.payload.id
    )
    const newArray = [...state.entities]
    newArray[index] = { ...newArray[index], status: 'Inactive' }
    if (payload.payload.id === state.entity?.id) {
      return {
        ...state,
        entity: { ...state.entity, status: 'Inactive' },
        entities: newArray,
      }
    }
    return {
      ...state,
      entities: newArray,
    }
  },
  [types.DELETE_ENTITIES]: (state: any, payload: any) => {
    const filteredEntities = state.entities.filter((entity: any) => {
      return entity.id !== payload.payload[0].id
    })

    return {
      ...state,
      entities: filteredEntities,
    }
  },
  [types.START_LOADING_ENTITIES]: (state: EntitiesState) => {
    return { ...state, isLoading: true }
  },
  [types.STOP_LOADING_ENTITIES]: (state: EntitiesState) => {
    return { ...state, isLoading: false }
  },
  [types.GET_ENTITY_HISTORY]: (state: any, payload: any) => {
      return { ...state, entityHistory: payload.payload }
    },
})

export default entitiesReducer
